import { parseBoolean } from '@amazon/vinyl-util'
import { queryParam } from '@/util/queryParams'

// When `?noCache=true` is in the querystring the gql layer goes
// network-only (skips the read/write of the SWR cache) so a debugging
// session always sees fresh server data. Read once at module load to
// mirror `core/debug.ts`; the toggle navigates (full reload) so a live
// read is unnecessary.
export const noCache = parseBoolean(queryParam('noCache'))
